import { BaseService } from './base-service';

class SalesService extends BaseService {
  /**
   *  售后服务--关键联系人--根据售后服务id查询关键联系人列表
   *
   * @author caoJianBo
   * @param  {Object} params
   * @returns
   * @memberof SetService
   */
  getContractList(params) {
    return this.request({
      method: 'get',
      url: `/sys-sales-key-contact/list`,
      params
    });
  }
  /**
   *  售后服务--关键联系人--新增
   *
   * @author caoJianBo
   * @param  {Object} data
   * @returns
   * @memberof SetService
   */
  addContract(data) {
    return this.request({
      method: 'post',
      url: `/sys-sales-key-contact/add`,
      data
    });
  }
  /**
   *  售后服务--关键联系人--编辑
   *
   * @author caoJianBo
   * @param  {Object} data
   * @returns
   * @memberof SetService
   */
  updateContract(data) {
    return this.request({
      method: 'post',
      url: `/sys-sales-key-contact/update`,
      data
    });
  }
  /**
   *  售后服务--关键联系人--删除
   *
   * @author caoJianBo
   * @param  {Object} params
   * @returns
   * @memberof SetService
   */
  deleteContract(params) {
    return this.request({
      method: 'get',
      url: `/sys-sales-key-contact/delete`,
      params
    });
  }
  /**
   *  售后服务--关键联系人--获取所有下拉列表选项值
   *
   * @author caoJianBo
   * @param  {Object} params
   * @returns
   * @memberof SetService
   */
  getSelectOption(params) {
    return this.request({
      method: 'get',
      url: `/sys-sales-key-contact/constants`,
      params
    });
  }
  /**
   *  售后服务--关键联系人--获取客户合作伙伴列表(天维度)
   *
   * @author caoJianBo
   * @param  {Object} data
   * @returns
   * @memberof SetService
   */
  getPartnerList(data) {
    return this.request({
      method: 'post',
      url: `/sys-sales-office-partner/list`,
      data
    });
  }
  /**
   *  售后服务--客户特征--根据售后服务id查询特征值
   *
   * @author caoJianBo
   * @param  {Object} params
   * @returns
   * @memberof SetService
   */
  getFeatureByTypeAndSealId(params) {
    return this.request({
      method: 'get',
      url: `/sys-sales/getFeatureByTypeAndSealId`,
      params
    });
  }
  /**
   *  售后服务--客户特征--根据售后服务修改特征值
   *
   * @author caoJianBo
   * @param  {Object} data
   * @returns
   * @memberof SetService
   */
  addOrUpdateFeature(data) {
    return this.request({
      method: 'post',
      url: `/sys-sales/addOrUpdateFeature`,
      data
    });
  }
  /**
   *  售后服务--动态记录--新增/编辑跟进类型的下拉选项值
   *
   * @author caoJianBo
   * @param  {Object} params
   * @returns
   * @memberof SetService
   */
  getFollowType() {
    return this.request({
      method: 'get',
      url: `/clue_record/followType`,
      params: { apiIndex: Math.random() }
    });
  }
}

export const salesService = new SalesService();
